import { render, staticRenderFns } from "./buy-package.vue?vue&type=template&id=e93542d4"
import script from "./buy-package.vue?vue&type=script&lang=js"
export * from "./buy-package.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports